/* eslint-disable react-hooks/exhaustive-deps */
/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
import { createContext, useContext, useEffect, useState } from "react";
import { useProgressValue } from "./progress-context";

export type Store = {
  storeId: number;
  name: string;
  status: number;
};

export interface FulfillmentCenter {
  fulfillmentCenterId: number;
  name: string;
  identifier: string;
  store: Store;
}

type InventoryContextType = {
  setIsFilterDataLoading: (isFilterDataLoading: boolean) => void;
  setIsResultsLoading: (isResultsLoading: boolean) => void;
  selectedStore?: Store;
  setSelectedStore: (selectedStore?: Store) => void;
  selectedFfmCenter?: FulfillmentCenter;
  setSelectedFfmCenter: (selectedFfmCenter?: FulfillmentCenter) => void;
  search: boolean;
  setSearch: (search: boolean) => void;
  sku?: string;
  setSku: (sku: string) => void;
  isLoading: boolean;
  isFilterDataLoading: boolean;
  isResultsLoading: boolean;
};

export const InventoryContext = createContext<InventoryContextType>({
  setIsFilterDataLoading: () => {},
  setIsResultsLoading: () => {},
  setSelectedStore: () => {},
  setSelectedFfmCenter: () => {},
  search: false,
  setSearch: () => {},
  setSku: () => {},
  isLoading: false,
  isFilterDataLoading: false,
  isResultsLoading: false,
});

export const InventoryDataProvider = ({ children }: any) => {
  const { setInProgress } = useProgressValue();
  const [isFilterDataLoading, setIsFilterDataLoading] = useState(true);
  const [isResultsLoading, setIsResultsLoading] = useState(false);
  const isLoading = isFilterDataLoading || isResultsLoading;
  const [selectedStore, setSelectedStore] = useState<Store | undefined>(
    undefined
  );
  const [selectedFfmCenter, setSelectedFfmCenter] = useState<
    FulfillmentCenter | undefined
  >(undefined);
  const [search, setSearch] = useState(false);
  const [sku, setSku] = useState("");

  useEffect(() => {
    setInProgress(isLoading);
  }, [isLoading]);

  return (
    <InventoryContext.Provider
      value={{
        setIsFilterDataLoading,
        setIsResultsLoading,
        selectedStore,
        setSelectedStore,
        selectedFfmCenter,
        setSelectedFfmCenter,
        search,
        setSearch,
        sku,
        setSku,
        isLoading,
        isFilterDataLoading,
        isResultsLoading,
      }}>
      {children}
    </InventoryContext.Provider>
  );
};

export const useInventoryContext = () => useContext(InventoryContext);
